export default function SiteFooter() {
  const cols = [
    { title: "下载专区", links: ["安卓下载", "苹果 iOS", "最新版本", "历史版本", "桌面客户端"] },
    { title: "版本动态", links: ["版本速递", "更新日志", "装机必备", "热门专题"] },
    { title: "使用帮助", links: ["下载百科", "安卓安装教程", "iOS 信任设置", "安全校验说明", "意见反馈"] },
  ];

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="max-w-sm">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-apps-2-fill text-lg"></i>
              </span>
              <span className="font-display text-lg font-bold text-foreground-950">吃瓜软件</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              吃瓜软件下载渠道全汇总，最新版本安装包、安卓下载、苹果安装一步到位，安全下载不吃亏、快速上手不迷路。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
              <i className="ri-shield-check-line text-accent-600"></i>
              全站安装包均经过安全校验后上架
            </p>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#channels"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-6xl flex-col items-start justify-between gap-2 px-4 py-5 text-xs text-foreground-400 md:flex-row md:items-center md:px-6">
          <p className="whitespace-nowrap">© 2026 吃瓜软件 · 下载渠道大全。仅供学习演示，请支持正版。</p>
          <p className="flex flex-wrap items-center gap-3">
            <a href="#guide" className="hover:text-primary-600">安装说明</a>
            <span className="hidden sm:inline">·</span>
            <a href="#guide" className="hover:text-primary-600">隐私政策</a>
            <span className="hidden sm:inline">·</span>
            <a href="#guide" className="hover:text-primary-600">免责声明</a>
          </p>
        </div>
      </div>
    </footer>
  );
}